import React from 'react';
import { useCountryPortStats } from '@hooks';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Grid } from '@esgian/esgianui';
import {
  PortTimeVsPortCallsChart,
  PortTimeYtdComparisonChart,
  PortTrafficChart
} from '@components/Charts';

const CountryStatisticsSection = ({ countryPortDetailsQuery, countryName = '' }) => {
  const params = useParams();
  const countryPortStatsQuery = useCountryPortStats(Number(params.countryId));
  const portIds = countryPortDetailsQuery.data?.map((port) => port.id) || [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <PortTimeVsPortCallsChart
          loading={countryPortStatsQuery.isFetching}
          portName={countryName}
          portStats={countryPortStatsQuery.data}
          fileName={`port-time-vs-port-calls-${countryName?.toLowerCase().split(' ').join('-')}`}
        />
      </Grid>
      <Grid item xs={6}>
        <PortTimeYtdComparisonChart
          portStats={countryPortStatsQuery.data}
          loading={countryPortStatsQuery.isFetching}
          portName={countryName}
          fileName={`port-time-change-${countryName?.toLowerCase().split(' ').join('-')}`}
        />
      </Grid>
      <Grid item xs={12}>
        <PortTrafficChart portIds={portIds} title={`ETA Statistics - ${countryName}`} />
      </Grid>
    </Grid>
  );
};
CountryStatisticsSection.propTypes = {
  countryName: PropTypes.string,
  countryPortDetailsQuery: PropTypes.object
};
export default CountryStatisticsSection;
